<template>
  <nav aria-label="Etapas do cadastro">
    <div class="d-block d-md-none step-description">
      Etapa {{ etapaAtual }} de {{ etapas.length }} —
      <strong>{{ tituloAtual }}</strong>
    </div>

    <div class="wizard-etapas d-none d-md-flex">
      <button
        v-for="etapa in etapas"
        :key="etapa.numero"
        type="button"
        class="wizard-etapa"
        :class="{ 'wizard-etapa--atual': etapa.numero === etapaAtual }"
        :disabled="!podeIr(etapa.numero)"
        :aria-current="etapa.numero === etapaAtual ? 'step' : null"
        :title="podeIr(etapa.numero) ? etapa.titulo : 'Conclua as etapas anteriores primeiro'"
        @click="$emit('selecionar', etapa.numero)"
      >
        <span class="step-dot" :class="classesMarcador(etapa.numero)">
          <fa-icon v-if="estado(etapa.numero) === 'concluida'" icon="check" />
          <fa-icon v-else-if="estado(etapa.numero) === 'erro'" icon="exclamation" />
          <template v-else>{{ etapa.numero }}</template>
        </span>
        <span class="wizard-etapa__textos">
          <span class="wizard-etapa__titulo">{{ etapa.titulo }}</span>
          <span class="wizard-etapa__resumo text-muted">{{ etapa.resumo }}</span>
        </span>
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: "WizardEtapas",
  props: {
    etapas: { type: Array, required: true },
    etapaAtual: { type: Number, required: true },
    /** Resultado de validarFormulario().porEtapa — { [numero]: { erros, avisos } } */
    porEtapa: { type: Object, default: () => ({}) },
    /** Etapas que o usuário já abriu — viram "concluída" quando estão válidas. */
    visitadas: { type: Array, default: () => [] },
    /** Etapas em que o erro já pode ser mostrado (tentou avançar ou é edição). */
    mostrarErros: { type: Object, default: () => ({}) },
    /** Na edição toda etapa é navegável: quem edita vai direto ao ponto. */
    navegacaoLivre: { type: Boolean, default: false },
  },
  computed: {
    tituloAtual() {
      const etapa = this.etapas.find((item) => item.numero === this.etapaAtual);
      return etapa ? etapa.titulo : "";
    },
  },
  methods: {
    /** Inválido de fato — usado para travar o pulo adiante. */
    invalido(numero) {
      const resultado = this.porEtapa[numero];
      return !!(resultado && resultado.erros.length);
    },
    /** Inválido E já pode ser apontado ao usuário. */
    temErro(numero) {
      return this.invalido(numero) && !!this.mostrarErros[numero];
    },
    estado(numero) {
      if (numero === this.etapaAtual) {
        return this.temErro(numero) ? "erro" : "atual";
      }
      if (this.temErro(numero)) {
        return "erro";
      }
      return !this.invalido(numero) && (this.visitadas.includes(numero) || numero < this.etapaAtual)
        ? "concluida"
        : "pendente";
    },
    // Mesmos estados do .step-dot do WizardTreinarIA: active para a etapa atual,
    // done para as concluídas.
    classesMarcador(numero) {
      const estado = this.estado(numero);
      return {
        active: estado === "atual",
        done: estado === "concluida",
        erro: estado === "erro",
      };
    },
    podeIr(numero) {
      if (this.navegacaoLivre || numero <= this.etapaAtual) return true;

      // Só libera pular adiante quando tudo que vem antes está válido — aqui vale
      // a validade real, não o que já está visível.
      for (let anterior = 1; anterior < numero; anterior++) {
        if (this.invalido(anterior)) return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>
.step-description {
  color: #667085;
  font-size: 13px;
}

.wizard-etapas {
  gap: 8px;
}

.wizard-etapa {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: none;
  text-align: left;
  min-width: 0;
}

.wizard-etapa:hover:not(:disabled) {
  background: #fafafa;
}

.wizard-etapa:disabled {
  cursor: not-allowed;
}

.wizard-etapa--atual {
  background: #f2f2f8;
}

/* Marcador na mesma medida e cores do wizard de treino da IA. */
.step-dot {
  flex: 0 0 auto;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  background: #e4e7eb;
  color: #667085;
}

.step-dot.active {
  background: #3a3e81;
  color: #fff;
}

.step-dot.done {
  background: #2298a3;
  color: #fff;
}

.step-dot.erro {
  background: #e55353;
  color: #fff;
}

.wizard-etapa__textos {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.wizard-etapa__titulo {
  font-size: 13px;
  font-weight: 600;
}

.wizard-etapa--atual .wizard-etapa__titulo {
  color: #3a3e81;
}

.wizard-etapa__resumo {
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
